import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.jpg";
import "../styles/navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = React.useState(false);

  // Close menu whenever the route changes
  React.useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleGetQuote = () => {
    closeMenu();
    navigate("/contact");
  };

  return (
    <>
      {/* NAVBAR */}
      <header className="navbar">
        <div className="logo-container">
          <img src={logo} alt="CEITCS Logo" />

          <div className="company-name">
            <h2 className="company-title">CeiTCS</h2>
            <span className="company-tagline">
              Cloud Enabled Intellectual Technology and Consultancy Services
            </span>
          </div>
        </div>

        <div className="right-section">
          <button
            className="quote-btn"
            onClick={handleGetQuote}
            type="button"
          >
            Get Quote
          </button>

          <div
            className={`menu-toggle ${menuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            ☰
          </div>
        </div>
      </header>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          className="overlay show"
          onClick={closeMenu}
        ></div>
      )}

      {/* SIDE MENU */}
      <nav className={`side-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li><Link to="/home" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/features" onClick={closeMenu}>Features</Link></li>
          <li><Link to="/services" onClick={closeMenu}>Services</Link></li>
          <li><Link to="/blog" onClick={closeMenu}>Blog</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>
          <li><Link to="/experts" onClick={closeMenu}>Experts</Link></li>
          <li><Link to="/careers" onClick={closeMenu}>Careers</Link></li>
          <li><Link to="/feedback" onClick={closeMenu}>Feedback</Link></li>
          <li><Link to="/client" onClick={closeMenu}>Clients</Link></li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;